import { IconButton } from "web/components"

import useSettingsModal from "./useSettingsModal"

export default function FieldSelector({ viewType, viewId }) {
  const showFieldSelectorModal = useSettingsModal({
    viewType,
    viewId,
  })

  return (
    <IconButton
      testId="button-field-selector"
      name="cog"
      outline
      onClick={showFieldSelectorModal}
    />
  )
}
